import { render, staticRenderFns } from "./separationMenuLeft.vue?vue&type=template&id=61e5b88e&scoped=true&"
import script from "./separationMenuLeft.vue?vue&type=script&lang=js&"
export * from "./separationMenuLeft.vue?vue&type=script&lang=js&"
import style0 from "./separationMenuLeft.vue?vue&type=style&index=0&id=61e5b88e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e5b88e",
  null
  
)

export default component.exports